__turbopack_context__.v({
  "bottom": "popover-module-scss-module__Ab-9ra__bottom",
  "close-button": "popover-module-scss-module__Ab-9ra__close-button",
  "close-wrapper": "popover-module-scss-module__Ab-9ra__close-wrapper",
  "end": "popover-module-scss-module__Ab-9ra__end",
  "entered": "popover-module-scss-module__Ab-9ra__entered",
  "entering": "popover-module-scss-module__Ab-9ra__entering",
  "header": "popover-module-scss-module__Ab-9ra__header",
  "popover": "popover-module-scss-module__Ab-9ra__popover",
  "start": "popover-module-scss-module__Ab-9ra__start",
  "title": "popover-module-scss-module__Ab-9ra__title",
  "up": "popover-module-scss-module__Ab-9ra__up",
});
